import { Component } from '@angular/core';

@Component({
  selector: 'rt-grid-overlay',
  templateUrl: './grid-overlay.component.html',
})
export class GridOverlayComponent{

}
